import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useEffect, useState } from "react"
import GlobalHelper from "../../common/GlobalHelper"
import ContactAddressFormatter from "../../state/contact/AddressFormatter"
import { ContactAddressDto } from "../../state/contact/models/contact"

type OwnProps = {
    value: ContactAddressDto
    lineStyle?: object
}

const AddressComponent = (props: OwnProps) => {
    const [address, setAddress] = useState<string[]>([])

    useEffect(() => {
        let canceled = false;

        (async () => {
            const address = { ... props.value }

            if (address.countryCode == "" && address.country != "") {
                address.countryCode = GlobalHelper.getCountryCodeFromLocalizedName(address.country,
                    AppContext.getLocale().getLanguageWithoutRegionCode(),
                )
            }

            if (address.countryCode !== "" && address.state !== "") {
                const stateCode = GlobalHelper.getStateCodeFromStateName(address.countryCode,
                    address.state,
                    AppContext.getLocale().getLanguageWithoutRegionCode(),
                )
                if (stateCode !== "") {
                    address.stateCode = stateCode
                }
            }

            const formattedAddress = await new ContactAddressFormatter(address).getFormattedAddressValues()
            if (!canceled) {
                setAddress(formattedAddress)
            }
        })()

        return () => {
            setAddress([])
            canceled = true
        }
    }, [props.value])

    if (!props.value) { return <></> }

    return (
        address.map((line, index) => {
            return <p className="m-0 p-0" style={props.lineStyle || {}} key={index}>
                {line}
            </p>
        }
        )
    )
}

export default AddressComponent


// WEBPACK FOOTER //
// ./src/customer/components/AddressComponent.tsx